// transforms/setupTransform.ts
import { SetupChecklistResponse, SetupChecklistItem } from "@/types/checklist";
import { SetupProgress } from "@/types/setup";

export const convertChecklistToProgress = (
  response: SetupChecklistResponse,
): SetupProgress => {
  // Create a map of item names to completion status
  const completionMap = new Map<string, boolean>();
  response.items.forEach((item) => {
    completionMap.set(item.name.replace(/\s+/g, ""), item.completed);

    // Also map any sub-items
    item.subItems?.forEach((subItem) => {
      completionMap.set(subItem.name.replace(/\s+/g, ""), subItem.completed);
    });
  });

  return {
    parentInformation: completionMap.get("ParentInformation") ?? false,
    employerManagement: completionMap.get("EmployerManagement") ?? false,
    employeeManagement: completionMap.get("EmployeeManagement") ?? false,
    pensions: completionMap.get("Pensions") ?? false,
    earnings: completionMap.get("Earnings") ?? false,
    timeOff: completionMap.get("TimeOff") ?? false,
    filings: completionMap.get("Filings") ?? false,
    payruns: completionMap.get("Payruns") ?? false,
  };
};

// Optional: Helper function to check if all required steps before a specific step are completed
export const arePrerequisitesComplete = (
  progress: SetupProgress,
  step: keyof SetupProgress,
): boolean => {
  const order: (keyof SetupProgress)[] = [
    "parentInformation",
    "employerManagement",
    "employeeManagement",
    "pensions",
    "earnings",
    "timeOff",
    "filings",
    "payruns",
  ];

  const stepIndex = order.indexOf(step);
  if (stepIndex === -1) return true; // If step not found in order, assume no prerequisites

  // Check all steps before this one
  for (let i = 0; i < stepIndex; i++) {
    if (!progress[order[i]]) return false;
  }

  return true;
};
